import { render } from "./PushNotificationsEdit.vue?vue&type=template&id=88817562"
import script from "./PushNotificationsEdit.vue?vue&type=script&lang=js"
export * from "./PushNotificationsEdit.vue?vue&type=script&lang=js"

import exportComponent from "/Users/borchekostovski/Documents/Projects/CreativeLabs/Projects/Ching-a-ling/ching-a-ling-cms-menu/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__